import React, { useEffect, useState } from 'react';
import { Pagination } from 'antd';
import { VirtualAccountFilterInitialValue } from './config/filterOptions';
import { VirtualAccountColumns } from "./components/VirtualAccountColumns";
import { useVirtualAccountQuery } from "./hooks/useVirtualAccountQuery";
import VirtualAccountFilter from "./components/VirtualAccountFilter";

const VirtualAccountPage: React.FC = () => {

    const [tempFilters, setTempFilters] = useState(VirtualAccountFilterInitialValue);
    const [filters, setFilters] = useState(VirtualAccountFilterInitialValue);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // 使用自定义hook获取数据
    const {
        virtualAccountData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    } = useVirtualAccountQuery(filters, currentPage, pageSize);

    const handleResetFilters = () => {
        setTempFilters(VirtualAccountFilterInitialValue);
        setFilters(VirtualAccountFilterInitialValue);
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    // 添加useEffect监听状态变化后执行查询
    useEffect(() => {
        refetch(buildQueryVariables());
    }, [filters, currentPage, pageSize]);

    // 处理分页变化
    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            {/* 筛选条件 */}
            <VirtualAccountFilter
                filters={tempFilters}
                setFilters={setTempFilters}
                handleFilter={handleFilter}
                handleResetFilters={handleResetFilters}
            />

            {/* 虚拟账户列表 */}
            <VirtualAccountColumns
                rowData={virtualAccountData}
                loading={loading}
                onRefresh={() => refetch(buildQueryVariables())}
            />

            {/* 分页 */}
            <div className="flex justify-between items-center">
                <div className="text-gray-500">{totalElements} results</div>
                <Pagination
                    current={currentPage}
                    total={totalElements}
                    pageSize={pageSize}
                    size="small"
                    showSizeChanger
                    onChange={handlePageChange}
                />
            </div>
        </div>
    );
};

export default VirtualAccountPage;
